<template>
  <div>
    <div v-if="isWide" class="dropdown">
      <button
        class="btn btn-outline-primary dropdown-toggle"
        type="button"
        :id="'dropdown-menu-' + safeField"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {{ label }}
        <font-awesome-icon :icon="['far', 'chevron-down']"></font-awesome-icon>
        <font-awesome-icon :icon="['far', 'chevron-up']"></font-awesome-icon>
      </button>
      <div :id="'dropdown-menu-content-' + safeField" class="dropdown-menu" :aria-labelledby="'dropdown-menu-' + safeField">
        <form>
          <div class="form-group">
            <input v-if="values.length > maxValues" class="form-control" v-model="term" :placeholder="l10n.filterPlaceholder">
            <div class="custom-control custom-checkbox" v-for="valMap in filteredValues" :key="valMap[0]">
              <input type="checkbox" :value="valMap[0]" class="custom-control-input" v-bind:checked="isChecked(valMap[0])" v-on:change="update(valMap[0])" :id="safeField + '-' + valMap[0]" />
              <label class="custom-control-label" :for="safeField + '-' + valMap[0]">
                {{ valMap[1] }}
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>

    <template v-else>
      <div class="card">
        <div class="card-header" :id="'search-heading-' + safeField">
          <h2 class="mb-0">
            <button
              class="btn btn-link btn-block text-left collapsed"
              type="button"
              data-toggle="collapse"
              :data-target="'#search-content-' + safeField"
              aria-expanded="true"
              :aria-controls="'search-content-' + safeField"
            >
              {{ label }}
              <font-awesome-icon :icon="['far', 'chevron-down']"></font-awesome-icon>
              <font-awesome-icon :icon="['far', 'chevron-up']"></font-awesome-icon>
            </button>
          </h2>
        </div>

        <div :id="'search-content-' + safeField" class="collapse" :aria-labelledby="'search-heading-' + safeField">
          <div class="card-body">
            <div class="form-group text-left">
              <input v-if="values.length > maxValues" class="form-control" v-model="term" :placeholder="l10n.filterPlaceholder">
              <div class="custom-control custom-checkbox" v-for="valMap in filteredValues" :key="valMap[0]">
                <input
                  type="checkbox"
                  :value="valMap[0]"
                  class="custom-control-input"
                  v-bind:checked="isChecked(valMap[0])"
                  v-on:change="update(valMap[0])"
                  :id="safeField + '--' + valMap[0]"
                />
                <label class="custom-control-label" :for="safeField + '--' + valMap[0]">
                  {{ valMap[1] }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch as faSearchRegular,
  faTimes as faTimesRegular,
  faUndo as faUndoRegular,
  faChevronDown as faChevronDownRegular,
  faChevronUp as faChevronUpRegular
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faSearchRegular, faTimesRegular, faUndoRegular, faChevronDownRegular, faChevronUpRegular);

export default {
  name: "SearchDropdown",
  model: {
    prop: "sdModel",
    event: "change"
  },
  props: {
    field: {
      type: String
    },
    label: {
      type: String
    },
    values: {
      type: Array
    },
    sdModel: {
      required: true
    },
    minWidth: {
      type: Number,
      default: 992
    },
    maxValues: {
      type: Number,
      default: 25
    }
  },
  data: function() {
    return {
      isWide: window.innerWidth >= this.minWidth,
      term: ''
    };
  },
  computed: {
    safeField: function() {
      return this.field.replace('.', '-').toLowerCase();
    },
    filteredValues: function() {
      if (this.values.length > this.maxValues) {
        let results = this.values.filter(word => word[1].includes(this.term));
        if (results.length > this.maxValues) {
          return [];
        }
        return results;
      }
      return this.values;
    },
    ...mapState({
      l10n: state => state.l10n
    })
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    isChecked: function(id) {
      id = parseInt(id);
      return this.sdModel.includes(id);
    },
    update: function(id) {
      let tmp = [...this.sdModel];
      id = parseInt(id);
      let i = tmp.indexOf(id);
      if (i === -1) {
        tmp.push(id);
      } else {
        tmp.splice(i, 1);
      }
      this.$store.commit("updateSelected", {
        field: this.field,
        value: tmp,
        path: []
      });
      this.$emit("change", tmp);
    },
    onWindowResize: function(e) {
      $('#dropdown-menu-' + this.safeField).dropdown('hide');
      this.isWide = window.innerWidth >= this.minWidth;
    }
  },
  components: {
    FontAwesomeIcon
    // Dropdown
  }
};
</script>

